@if (appContentContiner) {
<!--begin::Content container-->
<div
  id="kt_app_content_container"
  class="app-container"
  [ngClass]="appContentContainerClass + ' ' + contentContainerCSSClass"
  [ngClass]="{
    'container-xl': appContentContiner === 'fixed',
    'container-fluid': appContentContiner === 'fluid'
  }"
>
  <router-outlet></router-outlet>
</div>
<!--end::Content container-->
} @if (!appContentContiner) {
<router-outlet></router-outlet>
}
